import AppLinkButton from 'components/app/AppLinkButton';
import { BASE_IMG_URL } from '../../const/ConstBase';

import './MainOverview.scss';

interface Props {
    imgUrl: string;
    heading: string;
    description: string;
    buttonText: string;
    buttonLink: string;
    align?: string;
}

export const MainOverview = (props: Props) => {
    return (
        <div
            className='overview-container'
            style={{
                backgroundImage: `url(${BASE_IMG_URL}${props.imgUrl})`,
            }}
        >
            <div className={`overview-container-detail-wrapper ${props.align}`}>
                <h1 className='overview-heading'>{props.heading}</h1>
                <p className='overview-desc'>{props.description}</p>

                <AppLinkButton
                    buttonText={props.buttonText}
                    link={props.buttonLink}
                    isHover={false}
                />
            </div>
        </div>
    );
};
